export const SELECTOR_VALUES = [
  { code: 20, name: '20 registros por página' },
  { code: 50, name: '50 registros por página' },
  { code: 100, name: '100 registros por página' },
];
